import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { LoadingScreen, LogoThemeAware } from '../../atomic-atoms';

import style from './MarkdownRenderer.module.scss';

type MarkdownRendererProps = {
  markdownContent: string;
  showLogo: boolean;
};

export function MarkdownRenderer({
  markdownContent,
  showLogo = false,
}: MarkdownRendererProps) {
  if (!markdownContent) {
    return <LoadingScreen />;
  }

  return (
    <div className={style.markdownContainer}>
      {showLogo && (
        <div className={style.logoContainer}>
          <LogoThemeAware />
        </div>
      )}

      {/* <div style={{ maxHeight: '90vh', overflowY: 'auto' }}> */}
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {markdownContent}
      </ReactMarkdown>
      {/* </div> */}
    </div>
  );
}
